// Certifications Data - Centralized

export const certificationsData = [
  {
    id: 1,
    title: "Complete A.I. & Machine Learning, Data Science Bootcamp",
    issuer: "Udemy",
    issueDate: "July 2026",
    credentialUrl: "https://udemy-certificate.s3.amazonaws.com/image/UC-4821832a-44b2-4be6-a2c8-89691c986532.jpg",
  },
  {
    id: 2,
    title: "Git & GitHub Bootcamp",
    issuer: "Udemy",
    issueDate: "June 2022",
    credentialUrl: "https://www.udemy.com/certificate/UC-fb6df0be-f4bd-4ed0-9f94-20f0172652a2/",
  },
  {
    id: 3,
    title: "Google Cloud Ready Facilitator",
    issuer: "Google Cloud",
    issueDate: "July 2021",
    credentialUrl: "https://drive.google.com/file/d/1qQul9IyFtWBSatPtG6BBGRReqFREV623/view?usp=sharing",
  },
  {
    id: 4,
    title: "Data Science Orientation",
    issuer: "Coursera",
    issueDate: "June 2021",
    credentialUrl: "https://coursera.org/share/35662d1795a5ee643de7052c6be7dc99",
  },
  {
    id: 5,
    title: "What is Data Science?",
    issuer: "Coursera",
    issueDate: "June 2021",
    credentialUrl: "https://s3.amazonaws.com/coursera_assets/meta_images/generated/CERTIFICATE_LANDING_PAGE/CERTIFICATE_LANDING_PAGE~FVSNP34E2LNB/CERTIFICATE_LANDING_PAGE~FVSNP34E2LNB.jpeg",
  },
  {
    id: 6,
    title: "React - The Complete Guide",
    issuer: "Udemy",
    issueDate: "June 2021",
    credentialUrl: "https://www.udemy.com/certificate/UC-51b6f9c6-23c5-4aa2-bd02-58f4019cf18b/",
  },
  {
    id: 7,
    title: "Node.js, Express, MongoDB & More",
    issuer: "Udemy",
    issueDate: "February 2021",
    credentialUrl: "https://www.udemy.com/certificate/UC-ff78151d-0d22-47ce-b6e8-41dd56364bce/",
  },
];

export const educationData = [
  {
    id: 1,
    degree: "B.Sc IT",
    fullDegree: "Bachelor of Science in Information Technology",
    institution: "Institute of Hospitality, Management & Sciences",
    startDate: "Aug 2019",
    endDate: "Aug 2022",
    image: "/images/education/ihms.jpg",
  },
];
